import { render, staticRenderFns } from "./JoinBevelIcon.vue?vue&type=template&id=70fc259e&"
import script from "./JoinBevelIcon.vue?vue&type=script&lang=js&"
export * from "./JoinBevelIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports